import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { SparkSharedDataTableModule } from '@shared/components/data-table/data-table.module';
import { LoadModule } from '@shared/components/load/load.module';
import { MenuModule } from '@shared/components/menu/menu.module';
import { SparkSharedPaginationModule } from '@shared/components/pagination/pagination.module';
import { ProviderImageModule } from '@shared/components/provider-image/provider-image.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { SharedModule } from '@shared/shared.module';

import { OpportunityChartComponent } from './components/charts/opportunity/opportunity.component';
import { EmailCampaignMetricsReportComponent } from './components/canvas-metrics/canvas-metrics.component';
import { ContactsReportComponent } from './components/contacts/contacts.component';
import { LendingActivityComponent } from './components/lending-activity/lending-activity.component';
import { OpportunitiesReportComponent } from './components/opportunities/opportunities.component';
import { RefixesReportComponent } from './components/refix/refixes.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsLayoutComponent } from './views/layout/layout.component';

@NgModule({
  imports: [
    ReportsRoutingModule,
    NgxDatatableModule,
    SharedModule,
    ReactiveFormsModule,
    MenuModule,
    SparkSharedPaginationModule,
    CommonModule,
    LoadModule,
    ProviderImageModule,
    PipesModule,
    SparkSharedDataTableModule
  ],
  declarations: [
    ReportsLayoutComponent,
    EmailCampaignMetricsReportComponent,
    ContactsReportComponent,
    OpportunityChartComponent,
    LendingActivityComponent,
    OpportunitiesReportComponent,
    RefixesReportComponent
  ],
  exports: [LendingActivityComponent]
})
export class ReportsModule {}
